export const isLinkExternal = (href: string): boolean =>
  href.substr(0, 4) === 'http' ||
  href.startsWith('mailto:') ||
  href.startsWith('tel:')
